import {
  Component,
  Injector,
  Input,
  OnInit,
  Type,
  ViewChild,
  ViewContainerRef,
  ComponentRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalRef } from './modal-ref';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements OnInit {
  @Input() width = '600px';
  @Input() maxWidth = '95vw';
  @Input() disableBackdropClose = false;

  contentComponent: Type<unknown>;
  contentInjector: Injector;
  contentData: Record<string, unknown>;

  @ViewChild('contentContainer', { read: ViewContainerRef, static: true })
  contentContainer: ViewContainerRef;

  private contentRef: ComponentRef<unknown>;

  constructor(private modalRef: ModalRef) {}

  ngOnInit(): void {
    if (this.contentComponent) {
      this.contentRef = this.contentContainer.createComponent(
        this.contentComponent,
        { injector: this.contentInjector }
      );

      if (this.contentData) {
        Object.assign(this.contentRef.instance as Record<string, unknown>, this.contentData);
      }

      this.contentRef.changeDetectorRef.detectChanges();
    }
  }

  onBackdropClick(): void {
    if (!this.disableBackdropClose) {
      this.modalRef.close();
    }
  }


}
